import { gql } from "@apollo/client";

export const GET_DESTINATION_BY_COUNTRY = gql`
  query tripAnalytics(
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $countryCode: [CountryCode!]
    $transportType: Transport
    $offerType: Offer
    $departureCity: String
    $length: Int
    $mealCode: MealCode
  ) {
    tripAnalytics(
      start: $startDate
      finish: $endDate
      countryCode: $countryCode
    ) {
      statsByDate(
        filter: {
          transportType: $transportType
          offerType: $offerType
          departureCity: $departureCity
          length: $length
          mealCode: $mealCode
        }
      ) {
        date
        minimumBasePrice
        averageBasePrice
        maximumBasePrice
      }
    }
  }
`;

export const GET_REGIONS_AND_CITIES = gql`
  query tripAnalytics(
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
    $countryCode: CountryCode!
  ) {
    tripAnalytics(start: $startDate, finish: $endDate) {
      country(countryCode: $countryCode) {
        regions(first: 10) {
          totalCount
          nodes {
            name
          }
        }
        region(name: "") {
          cities(first: 10) {
            totalCount
            nodes {
              name
            }
          }
        }
      }
    }
  }
`;
